export default __webpack_public_path__ + "static/media/6.f55247a3.png";